import { render, staticRenderFns } from "./package-item.vue?vue&type=template&id=5f73fc4a&"
import script from "./package-item.vue?vue&type=script&lang=js&"
export * from "./package-item.vue?vue&type=script&lang=js&"
import style0 from "./package-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports